module.exports = __webpack_public_path__ + "static/media/avatar1.fb660b07.jpeg";